import { z } from '@harvestiq/zod';
import { safeDbEntityHistorySchema } from './db-entity-history';

export const deleteEntitiesHistoryResponseSchema = safeDbEntityHistorySchema;

export type DeleteEntitiesHistoryResponse = z.infer<
  typeof deleteEntitiesHistoryResponseSchema
>;
